import React from "react";
import { useState, useEffect } from "react";

function LeaderboardRecord(props) {
  const [isNameVisible, setIsNameVisible] = useState(true);

  useEffect(() => {
    const interval = setInterval(() => {
      setIsNameVisible((prevState) => !prevState);
    }, 3000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div
      style={{
        border: `2px solid ${props.posColor}`,
        color: props.posColor,
        borderRadius: "10px",
        backgroundColor: "#2f2f2f",
        width: "250px",
        height: "40px",
        padding: "7px",
        textAlign: "left",
        display: "flex",
        alignItems: "center",
        fontSize: "21px",
        position: "relative",
      }}
    >
      <span
        style={{
          position: "absolute",
        }}
      >
        <p>#{props.place} </p>
      </span>
      <span
        style={{
          position: "absolute",
          opacity: isNameVisible ? 1 : 0,
          transition: "opacity 0.5s ease",
          display: "flex",
          justifyContent: "space-between",
          width: "230px",
        }}
      >
        <p>#{props.place} </p>
        <p>{props.player}</p>
      </span>
      <span
        style={{
          position: "absolute",
          opacity: isNameVisible ? 0 : 1,
          transition: "opacity 0.5s ease",
          display: "flex",
          justifyContent: "space-between",
          width: "230px",
        }}
      >
        <p>#{props.place} </p>
        <p>{props.score}</p>
      </span>
    </div>
  );
}

export default LeaderboardRecord;
